import { type SupporterShowType } from '@frontend/contexts/supporters-management/types/supporterTypes'
import EmptyState from '@components/molecules/EmptyState'
import { scopedTranslation } from '@utils/I18n'

import NoteLogCard from './NoteLogCard'
import NewNoteForm from './NewNoteForm'

const t = scopedTranslation('components.notes_log')

type NotesLogProps = {
  notes: SupporterShowType['supporterNotes']['nodes']
  supporterId: string
  groupId: string
}

export default function NotesLog({ notes, supporterId, groupId }: NotesLogProps) {
  const hasNotes = notes.length > 0

  return (
    <div className="tw:flex tw:flex-col tw:gap-2" data-testid="notes-log">
      <div className="tw:shadow-xs tw:rounded-xl tw:border tw:border-gray-200 tw:*:border-b tw:*:border-gray-200 tw:[&>*:last-child]:border-b-0">
        <div className="tw:flex tw:py-5 tw:px-8 tw:gap-8 tw:text-sm tw:text-gray-700">
          <NewNoteForm supporterId={supporterId} groupId={groupId} />
        </div>
        {hasNotes ? (
          notes.map((note) => <NoteLogCard key={note.id} {...note} />)
        ) : (
          <EmptyState
            className="tw:border-0"
            iconType="book-open-01"
            headline={t('empty_state.title')}
          />
        )}
      </div>
    </div>
  )
}
